export const post = {
  fromGatsbyNode: gatsbyNode => {
    const { excerpt, fields, frontmatter } = gatsbyNode.node
    return { excerpt, fields, frontmatter }
  },
}
